<template>
  <div class="home">
    <div v-html="topHtml"></div>
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <keep-alive include="CertificateOverview">
      <router-view
        @openErrorDialog="openErrorDialog"
        @showSnackbar="showSnackbar"
      />
    </keep-alive>
    <div v-html="bottomHtml"></div>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Error</v-card-title
        >
        <v-card-text>
          <div class="dialogContent">{{ errorMessage }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Notification snackbar -->
    <v-snackbar v-model="snackbar" :timeout="12000">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "@/store/index.js";
import services from "@/services/services.js";

export default {
  name: "Home",
  data: () => {
    return {
      loginMethod: "",
      topHtml: "",
      bottomHtml: "",
      errorDialog: false,
      errorMessage: "",
      snackbar: false,
      snackbarMessage: "",
    };
  },
  methods: {
    login_normal() {
      this.$router.push({
        name: "Login",
        params: { loginMethod: this.loginMethod },
      });
    },
    login_afterSurveyCompletedNoParams(surveyCode) {
      //go to login page
      this.$router.push({
        name: "Login",
        params: {
          loginMethod: this.loginMethod,
          completedSurveyCode: surveyCode,
        },
      });
    },
    login_byQueryString(personId, personHash) {
      services.loginByQueryString(personId, personHash).then((resp) => {
        if (resp.data.hasError) {
          this.openErrorDialog(resp.data.errorMessage);
        } else {
          this.certificateOveriewResponseCb(resp);
        }
      });
    },
    login_byEncryptedUser(encryptedUser) {
      services.loginByEncryptedUser(encryptedUser).then((resp) => {
        if (resp.data.hasError) {
          this.openErrorDialog(resp.data.errorMessage);
        } else {
          this.certificateOveriewResponseCb(resp);
        }
      });
    },
    surveyCompleted_withParams(barcode, surveyCode, surveyHash) {
      services
        .surveyCompletedWithParams(barcode, surveyCode, surveyHash)
        .then((resp) => {
          if (resp.data.hasError) {
            this.openErrorDialog(resp.data.errorMessage);
          } else {
            this.certificateOveriewResponseCb(resp);
          }
        });
    },
    surveyCompleted_noParams(barcode, barcodeHash, surveyCode) {
      services
        .surveyCompletedNoParams(barcode, barcodeHash, surveyCode)
        .then((resp) => {
          if (resp.data.hasError) {
            this.openErrorDialog(resp.data.errorMessage);
          } else {
            this.certificateOveriewResponseCb(resp);
          }
        });
    },
    certificateOveriewResponseCb(resp) {
      if (resp.data.notification) {
        //alert(resp.data.notification);
        this.showSnackbar(resp.data.notification);
      }
      store.setBarcodeAction(resp.data.barcode);
      store.setBarcodeHashAction(resp.data.barcodeHash);
      this.setCookies(resp);
      this.$router.push({
        name: "CertificateOverview",
        params: { certificates: resp.data.certificates },
      });
    },
    setCookies(resp) {
      document.cookie = `cmCertificateBarcode=${resp.data.barcode}`;
      document.cookie = `cmCertificateBarcodeHash=${resp.data.barcodeHash}`;
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setViewConfigurations(viewConfiguration) {
      this.topHtml = viewConfiguration.home.topHtml;
      this.bottomHtml = viewConfiguration.home.bottomHtml;
      store.setLoginViewConfigurationAction(viewConfiguration.login);
      store.setCertificateOverviewViewConfigurationAction(
        viewConfiguration.certificateOverview
      );
      store.setCertificateDetailViewConfigurationAction(
        viewConfiguration.certificateDetail
      );
    },
    openErrorDialog(msg) {
      this.errorMessage = msg;
      this.errorDialog = true;
    },
    showSnackbar(msg) {
      this.snackbarMessage = msg;
      this.snackbar = true;
    },
  },
  mounted() {
    //Load settings and determine how the application was called (login, surveyCompleted, ...)
    let queryString = this.$route.query;
    if (queryString.eventCode) {
      //eventcode must always be present - if no configCode, set to normal
      let configCode = queryString.configCode;
      if (!configCode) {
        configCode = "normal";
      }

      store.setEventCodeAction(queryString.eventCode);
      services.setEventCodeAndConfigCode(queryString.eventCode, configCode);

      console.log(configCode);
      store.setConfigCodeAction(configCode);

      services.getEventSettings().then((resp) => {
        //todo: catch settings file not found!
        this.loginMethod = resp.data.loginMethod;
        //this.$vuetify.theme.dark = true;
        this.setViewConfigurations(resp.data.viewConfiguration);
        store.setisAutoRouteToSingleAvailalbeCertificate(
          resp.data.autoRouteToSingleAvailalbeCertificate
        );

        //determine entry method:
        if (queryString.surveyCode) {
          //a survey has been completed
          if (queryString.barcode) {
            //a survey that can return parameters was used
            this.surveyCompleted_withParams(
              queryString.barcode,
              queryString.surveyCode,
              queryString.surveyHash
            );
          } else {
            //a survey that can't return parameters was used

            //check if login data can ben gathered from cookies
            let barcode = this.getCookie("cmCertificateBarcode");
            let barcodeHash = this.getCookie("cmCertificateBarcodeHash");

            if (barcode && barcodeHash) {
              //if cookie: auto logon
              this.surveyCompleted_noParams(
                barcode,
                barcodeHash,
                queryString.surveyCode
              );
            } else {
              //if no cookie: go to login page and pass completed surveycode
              this.login_afterSurveyCompletedNoParams(queryString.surveyCode);
            }
          }
        } else {
          if (queryString.personId) {
            this.login_byQueryString(
              queryString.personId,
              queryString.personHash
            );
          } else {
            let cmCertificateWindowObject = window.cmCertificate;
            if (cmCertificateWindowObject) {
              this.login_byEncryptedUser(
                cmCertificateWindowObject.encryptedUser
              );
              //todo: login with encrypted user
            } else {
              this.login_normal();
            }
          }
        }
      });
    } else {
      console.log("No eventcode in querysting");
      console.log(this.$route);
    }
  },
};
</script>

<style lang="scss" scoped>
.dialogContent {
  margin: 10px 0;
}
</style>
